// Same RTDB project used by the Flutter app (superapp-topazio-dev).
// Replace appId with a dedicated Web app from the Firebase console when available.
export const firebaseConfig = {
  apiKey: 'AIzaSyDLoemI_fMu-6As6Qo2aP2QPU2CWekcj8g',
  authDomain: 'superapp-topazio-dev.firebaseapp.com',
  databaseURL: 'https://superapp-topazio-dev-default-rtdb.firebaseio.com',
  projectId: 'superapp-topazio-dev',
  storageBucket: 'superapp-topazio-dev.appspot.com',
  messagingSenderId: '268888449637',
  appId: '1:268888449637:web:allowme-ib',
};
